<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body=""
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="certificate"
      label-position="left"
      :rules="rules"
      label-width="85px">
      <el-form-item
        v-if="certificate.vendorId"
        label="证书名称:"
        prop="certName">
        <el-input v-model.number="certificate.certName"></el-input>
      </el-form-item>
      <el-form-item
        v-else
        label="证书名称:">
        <span>{{ certificate.certName }}</span>
      </el-form-item>
      <el-form-item
        label="有效期:"
        prop="time">
        <el-date-picker
          v-model="certificate.time"
          style="width: 100%;"
          type="daterange"
          unlink-panels
          range-separator=""
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="证书文件:"
        prop="certFile">
        <upload-with-crop
          v-model="certificate.certFile"
          :limit="5"
          :isLt2M="500"
          :fixedNumber="[1,1]"
          :autoCropWidth="100"
          :autoCropHeight="100" />
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
export default {
  name: 'CertificateModal',
  components: { UploadWithCrop },
  data() {
    return {
      loading: false,
      visible: false,
      certificate: { vendorId: null, vendorName: '', certFileId: null, certId: null, certName: '', time: '', certFile: [] },
      rules: {
        certName: [{ required: true, message: '请输入证书名称', trigger: 'blur' }],
        time: [{ required: true, message: '请选择有效期', trigger: 'blur' }],
        certFile: [{ required: true, message: '请上传证书文件', trigger: 'change' }]
      }
    }
  },
  computed: {
    title({ certificate }) {
      const { vendorId, certFileId } = certificate
      return (vendorId) ? '新建证书' : (certFileId ? '修改证书文件' : '新建证书文件')
    }
  },
  methods: {
    init(row = {}) {
      this.certificate = { ...this.certificate, ...row }
      this.visible = true
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.certificate = { ...this.certificate, ...this.$options.data().certificate, time: undefined }
    },
    handleLoading(loading) {
      this.loading = loading
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const { vendorId, certFileId } = this.certificate
          if (vendorId) {
            this.addcertificate()
          } else if (certFileId) {
            this.updatecertificatefile()
          } else {
            this.addcertificatefile()
          }
        }
      })
    },
    getQuery() {
      const { time, certFile } = this.certificate
      return { certBeginTime: +time[0], certEndTime: +time[1], certFile: certFile.map(item => item.url).join(',') }
    },
    addcertificate() {
      this.loading = true
      this.$$examApi.addcertificate({ certLevel: 1, ...this.certificate, ...this.getQuery(this.certificate) })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if ([0].includes(result)) {
            this.loading = false
            this.visible = false
            this.$emit('fetch')
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    updatecertificatefile() {
      this.loading = true
      this.$$examApi.updatecertificatefile({ ...this.certificate, ...this.getQuery(this.certificate) })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if ([0].includes(result)) {
            this.loading = false
            this.visible = false
            this.$emit('fetch')
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    addcertificatefile() {
      this.loading = true
      this.$$examApi.addcertificatefile({ ...this.certificate, ...this.getQuery(this.certificate) })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if ([0].includes(result)) {
            this.loading = false
            this.visible = false
            this.$emit('fetch')
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
